import { useEffect, useState } from "react";
import { BasePageContainer } from "../../../../components/common";
import CustomLoader from "../../../../components/common/CustomLoader";
import EmotionalLevelBarChart from "./charts/EmotionalLevelBar";
import EmotionalLevelAreaChart from "./charts/EmotionalLevelArea";
import ImpartRecommendation from "./ImpartRecommendation";
import ImpartRecentAnalysis from "./ImpartRecentAnalysis";
import { Link } from "react-router-dom";
import constant from "../../../../helper/constant";
import { EL_AREA_DATA, EL_BAR_DATA } from "../../../../service/mock-data/impart";
import { getImpartDashboardData } from "../../../../service/ai-model.service";

const ImpartDashboard = () => {

    const [loading, setLoading] = useState(false);
    const [dashboardData, setDashboardData] = useState({ elBar: EL_BAR_DATA, elArea: EL_AREA_DATA });

    useEffect(() => {
        setLoading(true);
        getImpartDashboardData()
            .then(r => {
                setDashboardData(r);
            })
            .finally(() => setLoading(false));
    }, []);

    const renderContentIMpactAnalyzer = () => {
        return <>
            <section className="mt-4">
                <div className="container">
                    <div className="text-blue font-18 mb-3">Content Impact Analyzer</div>
                    <div className="row align-items-center">
                        <div className="col-md-3">
                            <div className="Recent-Analyses-sub-box p-3 text-center">
                                <div className="text-black font-18"><b>Predicted Success Score </b></div>
                                <div className="text-blue Recent-Analyses-sub-box-heading">80%</div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="Recent-Analyses-sub-box p-3 text-center">
                                <div className="text-black font-18"><b>Impact Score</b></div>
                                <div className="text-blue Recent-Analyses-sub-box-heading">85</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2">Emotional Level (EL) Diversity</div>
                            <div className="chart-bg border p-3" style={{ height: 250 }}>
                                <EmotionalLevelBarChart data={dashboardData.elBar} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    }

    const renderEmotionalLevelDiversity = () => {
        return (
            <section className="mt-4">
                <div className="container">
                    <div>
                        <div className="mb-2">Emotional Level (EL) Diversity</div>
                        <div className="chart-bg border p-3" style={{ height: 350 }}>
                            <EmotionalLevelAreaChart data={dashboardData.elArea} />
                        </div>
                    </div>
                    <div className="text-center mt-3">
                        <Link className="btn1 rounded btn-loader" to={`${constant.PAGES.IMPART_AI.IMPART_AI_DETAIL}`} relative>Get Detail Chart <span className="btn-ring"></span></Link>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <BasePageContainer>
            {loading && <CustomLoader full />}
            {renderContentIMpactAnalyzer()}
            {renderEmotionalLevelDiversity()}
            <ImpartRecommendation />
            <ImpartRecentAnalysis />
        </BasePageContainer>
    );
};

export default ImpartDashboard;
